
     
 <template>
  <v-card color="grey lighten-4" tile loading>
    <v-toolbar dense color="grey lighten-3" v-if="showToolbar">
      <v-btn tile color="primary" v-on:click="GoToPrevPage()">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <v-btn class="mx-1" small outlined color="primary" dark v-if="!isMobile"
        >{{ moment(selectedPeriodStart).format("DD/MM/YYYY") }} -
        {{ moment(selectedPeriodEnd).format("DD/MM/YYYY") }}</v-btn
      > 
      <v-btn tile color="primary" v-on:click="GoToNextPage()">
        <v-icon> mdi-arrow-right </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="title != undefined">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        tile
        class="calendar-action-btn"
        :style="!action.visible ? 'display:none' : ''"
        v-bind:color="
          action.vuetifyColor != undefined ? action.vuetifyColor : 'primary'
        "
        v-for="(action, index) in actions"
        :key="index"
        v-on:click="action.action(selectedItems)"
      >
        <v-icon
          left
          v-if="
            String(
              action.vuetifyIcon != undefined ? action.vuetifyIcon : ''
            ).startsWith('mdi-')
          "
        >
          {{ action.vuetifyIcon }}
        </v-icon>
       <span  v-if="!isMobile"> {{ action.text }}</span>
      </v-btn>
    </v-toolbar>
 
    <v-simple-table fixed-header v-bind:height="height">
      <template v-slot:default>
        <thead>
          <tr >
            <th class="text-right">{{ itemsHeader }}</th>
            <th
              class="text-center"
              v-bind:class="GetHeaderCellClass(day.date)"
              v-for="(day, index) in visibleDays"
              :key="index"
            >
              <div>
                <span class="title">{{ moment(day.date).format("DD") }}</span
                ><span class="subtitle-2"
                  >/{{ moment(day.date).format("MM") }}</span
                >
              </div>
              {{ day.label }}<br />
            </th>
          </tr>
        </thead>
        <tbody>
          
      
          <tr v-for="(item,iItems) in items" :key="item[itemKey]" :class="'calendar-item calendar-item-'+iItems">
            <td class="text-right">{{ item[itemText] }}</td>
            <td
              class="pa-0 operator-day-cells"
              v-for="(day, index) in visibleDays"
              :key="index"
            >
              <slot
                name="cell-content"
                v-bind="{ date: day, item: item, checked: false }"
              >
                <v-btn tile> </v-btn>
              </slot>
            </td>
          </tr> 
        </tbody>
      </template>
    </v-simple-table> 
    <!-- <p>start at {{ moment(selectedWeeFkStart).format("YYYY-MM-DD") }}</p>
    <p>end at {{ moment(selectedWeekEnd).format("YYYY-MM-DD") }}</p> -->

    <!-- FOOTER -->
    <v-card ref="pnlFilter">
      <v-card-actions v-if="showOptions">
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-checkbox
                  v-model="startFromToday"
                  :label="`Start From Today`"
                ></v-checkbox> </v-col
              ><v-col cols="4" sm="4" md="4">
                <v-checkbox
                  v-model="fitMaxDaysVisible"
                  :label="`Fit visible days`"
                ></v-checkbox>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-slider
                  v-model="maxDaysToShow"
                  label="Max giorni"
                  thumb-color="blue"
                  v-bind:disabled="Boolean(fitMaxDaysVisible)"
                  :thumb-label="true"
                  style="margin-top: 28px"
                  max="31"
                  min="1"
                ></v-slider>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-select
              v-model="daysToShow"
              :items="
                labels.map((v, i) => {
                  return { id: i, text: v };
                })
              "
              item-value="id"
              item-text="text"
              chips
              label="Days to show"
              multiple
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-card>
</template>


<style lang="scss">
.calendar-action-btn {
  margin: 2px;
}
tr:hover {
  background: transparent !important;
}
td.operator-day-cells:hover {
  // background: rgb(155, 155, 155) !important;
}
td.operator-day-cells {
  background: rgb(238, 238, 238) !important;
  cursor: pointer;
  padding: 0px !important;
}
td {
  border-right: 1px solid rgb(155, 155, 155) !important;
}
</style>


<script>
 
import moment, { normalizeUnits } from "moment";

export default {
  props: {
    height: { type: String }, 
    showOptions: {
      type: Boolean,
      default: true,
    },
    showToolbar: {
      type: Boolean,
      default: true,
    },
    labels: {}, //["Domenica","Lunedì","Martedì"...] //alla posizione 0 deve corrispondere la domenica, alla 1 => lunedì e via così
    DaysToShow: {}, //[0,1,2,3,4,5,6] posizione usata per determinare se mostrare un elemento o meno
    StartFromToday: {},
    FitMaxDaysVisible: {},
    title: {},
    startWeekDay: {}, ///XXXXXXXX
    MaxDaysToShow: {},
    //Gestione operai
    itemsHeader: {},
    items: {},
    actions: {},
    itemKey: {}, //Campo che identifica univocamente l'item
    itemText: {}, //Campo da usare come text della cella
  },
  components: {},
  data() {
    return {
      days: [],
    isMobile:false,
      creationDate: new Date(),
      menu2: false,
      datePointer: new Date(),
      startFromTodayFlag: false,
      fitMaxDaysVisibleFlag: false,
      maxDaysToShow: 7,
      daysToShow: [],
      tableHeight: 0,
      selectedDay: null,
      backMaxDaysToShow: 0,
      selectedItems: [],
      defaultLabels: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    };
  },
  beforeCreate() {},
  mounted() {
    this.creationDate = new Date(
      Date.parse(moment(new Date()).format("MM/DD/YYYY"))
    );
    setInterval(this.checkIfHaveToChangeDay, 2000);
    if(this.$route.query.date){
      this.datePointer=new Date(Date.parse(this.$route.query.date));
      console.log("DATE POINTER",this.datePointer);
    }
    this.reloadGrid();
  },
  created() {
  },

  watch: {
    FitMaxDaysVisible: function (val) {
      this.fitMaxDaysVisible = val;
    },
    daysToShow: function (val) {
      this.days = this.calculateDays(this.datePointer, val, this.maxDaysToShow);
      this.updateDays();
    },
    maxDaysToShow: function (val) {
      this.days = this.calculateDays(this.datePointer, this.daysToShow, val);
      this.updateDays();
    },
  },
  computed: {
    fitMaxDaysVisible: {
      get() {
        return this.fitMaxDaysVisibleFlag;
      },
      set(value) {
        this.fitMaxDaysVisibleFlag = value;
        this.updateDays();
      },
    },
    visibleDays() {
      return this.getVisibleDays(this.days, this.daysToShow, this.labels);
    },
    startFromToday: {
      get() {
        return this.startFromTodayFlag;
      },
      set(value) {
        if (value) {
          this.datePointer = new Date(); //TODO: a voler fare le cose fatte bene, qui dovrebbe riprendere dal giorno * settimane avanti perchè se sono andato avanti di 3 periodi, così ritorna a quello corrente
        } else if (this.days.length > 0) this.datePointer = this.days[0].date;
        else this.datePointer = new Date();
        this.startFromTodayFlag = value;

        this.days = this.calculateDays(
          this.datePointer,
          this.daysToShow,
          this.maxDaysToShow
        );
      },
    },
    selectedPeriodStart: {
      get() {
        if (this.days.length > 0) return this.visibleDays[0].date;
        else return new Date();
      },
    },

    selectedPeriodEnd: {
      get() {
        if (this.days.length > 0)
          return this.visibleDays[this.visibleDays.length - 1].date;
        else return new Date();
        // if (this.days.length > 0)
        //   return this.visibleDays[] != undefined
        //     ? this.visibleDays[this.days.length - 1].date
        //     : new Date();
        // else return new Date();
      },
    },
  },
  methods: {
    
  checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
    reloadGrid() {
      this.checkIfIsMobile();
      if (this.StartFromToday != undefined) {
        this.startFromToday = this.StartFromToday;
      } else {
        this.startFromToday = false;
        // this.datePointer = this.getStartWeek(new Date()); //TODO: questa data potrebbe essere passata come parametro
      }
      if (this.FitMaxDaysVisible != undefined)
        this.fitMaxDaysVisible = this.FitMaxDaysVisible;
      if (this.MaxDaysToShow != undefined)
        this.maxDaysToShow = this.MaxDaysToShow;
      if (!this.labels || this.labels == undefined) {
        this.labels = this.defaultLabels;
      }
      if (!this.maxDaysToShow) this.maxDaysToShow = 6;
      this.daysToShow = this.DaysToShow;
      if (!this.daysToShow) {
        this.daysToShow = [0, 1, 2, 3, 4, 5, 6];
      }

      this.days = this.calculateDays(
        this.datePointer,
        this.daysToShow,
        this.maxDaysToShow
      );
    },
    checkIfHaveToChangeDay() {
      let t = this;
      console.info("check if i've to add day");
      let curDate = new Date(
        Date.parse(moment(new Date()).format("MM/DD/YYYY"))
      );
      let diff = curDate.getTime()- t.creationDate.getTime() ;
      let daysDec = diff / (1000 * 3600 * 24);
      console.info("curDate", curDate.getTime());
      console.info("creationDate", t.creationDate.getTime());
      console.info("daysDec", daysDec);
      let days = Math.floor(daysDec);
      console.info("days", days);
      if (days > 0) { 
        let date = t.datePointer;
        let nextDate = t.addDays(date, 1);
        console.info("going to next", nextDate);
        t.creationDate = new Date(
          Date.parse(moment(new Date()).format("MM/DD/YYYY"))
        ); 
        t.datePointer=nextDate;
        console.info("datePointer", t.datePointer);
        console.info("GetPeriodStart", t.GetPeriodStart());
        console.info("GetPeriodEnd", t.GetPeriodEnd());
        t.updateDays();
        // router.push({
        //   name: "plan-viewer",
        //   query: { date:  moment(nextDate).format("MM/DD/YYYY")   },
        // }); 
        console.info("DAYS",t.days);
        console.info("VISIBLE DAYS",t.visibleDays);
      }
      // this.$route.query.date = moment(this.addDays(date, days)).format(
      //   "MM/DD/YYYY"
      // );
    },

    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    updateDays() {
      if (this.fitMaxDaysVisible) {
        this.backMaxDaysToShow = this.maxDaysToShow;
        this.maxDaysToShow = this.daysToShow.length;
      }
      //  else {
      //   this.maxDaysToShow = 7;//this.backMaxDaysToShow;
      // } 
      this.days = this.calculateDays(
        this.datePointer,
        this.daysToShow,
        this.maxDaysToShow
      );

      this.$emit(
        "periodChanged",
        this.selectedPeriodStart,
        this.selectedPeriodEnd
      );
    },
    getVisibleDays(days, daysToShow, labels) {
      let filtered = days.filter(
        (d) => daysToShow.find((day) => day == d.date.getDay()) != undefined
      );
      return filtered;
    },
    calculateDays(referenceDate, daysToShow, maxDaysToShow) {
      let days = [];
      if (daysToShow.length <= 0) return [];

      for (
        let i = this.startFromToday
          ? referenceDate.getDate()
          : this.getStartWeek(referenceDate).getDate(); //Se c'è lo startFromToday, parto dal giono di oggi,altrimenti parto da domenica
        this.getVisibleDays(days, daysToShow, this.labels).length <
        maxDaysToShow;
        i++
      ) {
        let date = new Date(referenceDate);
        date.setDate(i);
        let dayOfWeek = date.getDay(); //0,1,2,3,4,5,6
        //filtro giorni specifici della settimana (oppure prendo quelli di default popolato nel create)
        let label = this.labels[dayOfWeek];
        // if (
        //   label != undefined &&
        //   daysToShow.find((d) => d == dayOfWeek) != undefined
        // ) {
        let dayObj = {
          label: label,
          dayOfWeek: dayOfWeek,
          date: date,
        };
        days.push(dayObj);
      }
      // }
      return days;
    },
    GetHeaderCellClass(date) {
      if (
        moment(this.selectedDay).format("DDMMYYYY") ==
        moment(date).format("DDMMYYYY")
      )
        return "red lighten-3";
      else return "";
    },
    GetPeriodStart() {
      return this.selectedPeriodStart;
    },
    GetPeriodEnd() {
      return this.selectedPeriodEnd;
    },

    GoToNextPage() {
      let date = new Date(this.visibleDays[0].date);
      if (this.startFromToday) {
        date = new Date(this.datePointer);
      }
      let inc = date.getDate() + this.days.length;
      date.setDate(inc);
      this.datePointer = date;
      this.days = this.calculateDays(date, this.daysToShow, this.maxDaysToShow);

      this.$emit(
        "periodChanged",
        this.selectedPeriodStart,
        this.selectedPeriodEnd
      );
    },
    GoToPrevPage() {
      let date = new Date(this.visibleDays[0].date);
      if (this.startFromToday) {
        date = new Date(this.datePointer);
      }
      let inc = date.getDate() - this.days.length;
      date.setDate(inc);
      this.datePointer = date;
      this.days = this.calculateDays(date, this.daysToShow, this.maxDaysToShow);

      this.$emit(
        "periodChanged",
        this.selectedPeriodStart,
        this.selectedPeriodEnd
      );
    },
    getStartWeek(currentDate) {
      let selectedDayOfWeek = currentDate.getDay();
      let date = new Date(currentDate);
      date.setDate(currentDate.getDate() - selectedDayOfWeek);
      return date;
    },
    getEndWeek(currentDate) {
      let startDate = this.getStartWeek(currentDate);
      let date = new Date(startDate);
      date.setDate(startDate.getDate() + 6);
      return date; // + 6;
    },

    moment: moment, 
  },
};
</script>